module.exports = __webpack_public_path__ + "static/media/globe.23ddade3.svg";